module.exports = new __parcel__URL__("error-triangle-basic.6c1bbfdc.svg").toString();